import routerOptions0 from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}